"use client";
import type { getProductSizes } from "@frend-digital/centra-legacy/src/formatting/atomics/baseAtomics";
import isEqual from "lodash.isequal";
import { usePathname, useSearchParams } from "next/navigation";
import { useState } from "react";

export type ProductSizes = ReturnType<typeof getProductSizes>;

type ProductSize = {
  fewLeft: boolean;
  name: string;
  label: string;
  stock: boolean;
  itemId: string;
};

export type Sizes = ReturnType<typeof useSizes>["sizes"];

const useSizes = (sizes?: ProductSize[]) => {
  const initialSize = useSearchParams().get("size");
  const [selected, setSelected] = useState<ProductSize | null>(
    sizes?.find((size) => size.label === initialSize) || null
  );
  const pathname = usePathname();

  const onSizeSelect = (size: ProductSize) => {
    //set selected sizeId as query param
    const newParams = new URLSearchParams(window.location.search);
    newParams.set("size", size.label);
    window.history.pushState({}, "", `${pathname}?${newParams.toString()}`);

    setSelected(size);
  };
  //
  const formattedSizes = sizes?.map((size: ProductSize) => {
    return {
      ...size,
      isSelected: isEqual(selected?.itemId, size?.itemId),
      selectSize: () => onSizeSelect(size),
    };
  });

  return {
    sizes: formattedSizes,
    selectedSize:
      selected !== null
        ? selected
        : sizes?.length === 1
          ? sizes?.[0]
          : undefined,
  };
};

export default useSizes;
